<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }" icon="fas fa-tasks">
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import { SQDCActionStatus } from "@/graphql";
import StatusFilter from "../../filterImplementations/StatusFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps({
  filter: {
    type: Object as PropType<StatusFilter>,
    required: true,
  },
});
const { t } = useTranslation();
function statusLabel(status: SQDCActionStatus) {
  switch (status) {
    case SQDCActionStatus.PLAN:
      return t("views.pdca.plan");
    case SQDCActionStatus.DO:
      return t("views.pdca.do");
    case SQDCActionStatus.CHECK:
      return t("views.pdca.check");
    case SQDCActionStatus.ACT:
      return t("views.pdca.act");
  }
}
const text = computed(() => props.filter.status.map(statusLabel).join(", "));
</script>

<style lang="scss" scoped></style>
